/**
 * Created with zhengchao04 on 2018-08-21 11:33:19.
 * Description: 映射途径(厂商门店映射)
 *
 * @author zhengchao04@meituan.com
 * @version 1.0.0
 */
export const mappingChannels = {
  10: '接口上传',
  20: '手工导入'
};



// WEBPACK FOOTER //
// ./src/config/mappingChannels.js